import React from "react";
import ReactDOM from "react-dom/client"; //Framework for
// building web applications
import "./index.css";
import App from "./app/App";
import { Provider } from "react-redux";
import { store } from 'app/store';
import { HashRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
